import React from 'react';
import ReactMarkdown from 'react-markdown';
import remarkBreaks from 'remark-breaks';
import remarkGfm from 'remark-gfm';
import { Box } from '@mui/material';
import { markdownBodySx } from './markdownBodySx';

/**
 * Markdown render with HTML disabled and javascript: URLs stripped.
 * Supports GFM tables and single-line breaks via remark plugins.
 */
export default function SafeMarkdown({
  children,
  className = 'markdown-body',
  sx,
  markdownBaseSx = markdownBodySx,
  ...rest
}) {
  const value = typeof children === 'string' ? children : String(children ?? '');
  return (
    <Box
      className={className}
      sx={{
        whiteSpace: 'normal',
        ...markdownBaseSx,
        ...sx,
      }}
    >
      <ReactMarkdown
        skipHtml
        remarkPlugins={[remarkGfm, remarkBreaks]}
        urlTransform={(url) => (/^javascript:/i.test(String(url)) ? '' : url)}
        {...rest}
      >
        {value}
      </ReactMarkdown>
    </Box>
  );
}
